import { Card, CardContent, CardHeader, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import { ArrowBack } from "@mui/icons-material"
import MaterialTypography from "../../../components/MaterialTypography"
import { useNavigate, useSearchParams } from "react-router-dom"
import MaterialBox from "../../../components/MaterialBox"
import MaterialInput from "../../../components/MaterialInput"
import MaterialSelect from "../../../components/MasterSelect"
import { useCityFormHandling } from "./components/CityStateHandle"
import MaterialButton from "../../../components/MaterialButton"
import { useEffect, useState } from "react"
import { fetchData, fetchDataById, postData, putData } from "../../../services"
import { useSnackbar } from "../../../context/popup"

const CityForm = () => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const {showSnackbar} = useSnackbar();
    const cityId = searchParams.get("id");
    const pageType = searchParams.get("pageType");
    const pageMode = pageType === "view" ? "view" 
    : pageType === "edit" ? "edit" : "add";
    const [countryDropdownOptions, setCountryDropdownOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const { formData, setFormData, handleChange, checkAllFields } = useCityFormHandling();
    
    //Country Dropdown API
    useEffect(() => {
        if(pageMode!=="view"){
            const fetchCountryDropdown = async () => {
            try {
                const response = await fetchData(`/reference/general/country?dropdown=true&isActive=true`)                
                if(response?.success){
                const formattedCountries = response?.data?.items?.map((item) => ({
                    value: item.id,
                    label: item.displayName,
                }));
                
                setCountryDropdownOptions(formattedCountries);                }
                else{
                    //throw error
                }
                } catch (error) {
                console.error('Error Fetching Countries:', error);
                showSnackbar(error?.response?.data?.message || 'Error Fetching Countries', "error");
                }
            };
            fetchCountryDropdown();
        }
        
    },[pageMode])

    //State Dropdown API
    useEffect(() => {
        if (!formData.countryId?.value) return;
        const fetchStateDropdown = async (countryId) => {
            try {
            const response = await fetchData(`/reference/general/state?dropdown=true&isActive=true&countryId=${countryId}`)
            
            if(response?.success){
                const formattedStates = response?.data?.items.map((item) => ({
                value: item.id,
                label: item?.name
                }))
                setStateOptions(formattedStates);
            }
            else{
                //throw error
            }
            }       
            catch (error) {
            console.error('Error Fetching States:', error);
            showSnackbar(error?.response?.data?.message || 'Error Fetching States', "error");            
            }
        };
        fetchStateDropdown(formData.countryId.value);
    }, [formData.countryId?.value]);

    //District Dropdown API
    useEffect(() => {
        if (!formData.stateId?.value) return;

        const fetchDistrictDropdown = async () => {

            try {
            const response = await fetchData(`/reference/general/district?dropdown=true&isActive=true&stateId=${formData.stateId?.value}`)
            
            if(response?.success){
                const formattedDistricts = response?.data?.items.map((item) => ({
                    value: item.id,
                    label: item?.name
                }))
                setDistrictOptions(formattedDistricts);
            }
            else{
                //throw error
            }
            } catch (error) {
            console.error('Error Fetching Districts:', error);
            showSnackbar(error?.response?.data?.message || 'Error Fetching Districts', "error");
            }
        }
        fetchDistrictDropdown();
    }, [formData.stateId?.value]);

    //data fetch by id api function
    useEffect(() => {
        if((pageMode === "add") || (!cityId)){
        return
        }
        const fetchCityById = async (cityId) => {
        try {
            const response = await fetchDataById(`/reference/general/city/${cityId}`);
            const responseData = response?.data;
            if(response.success){
                setFormData(prev => ({
                ...prev,
                name: responseData?.name || "",
                code: responseData?.code || "",
                active: responseData?.isActive,
                countryId: { value: responseData?.district?.state?.country?.id || "" , label : responseData?.district?.state?.country?.name || ""},
                stateId: {value: responseData?.district?.state?.name || "",label: responseData?.district?.state?.name || ""},
                districtId: {value: responseData?.district?.id || "",label: responseData?.district?.name || ""},
                iplCityId: responseData?.id || "",
                // reset status fields
                nameStatus: responseData?.name ? "success" : "unchecked",
                codeStatus: responseData?.code ? "success" : "unchecked",
                countryIdStatus: responseData?.district?.state?.country?.id ? "success" : "unchecked",
                stateIdStatus: responseData?.district?.state?.name ? "success" : "unchecked",
                districtIdStatus: responseData?.district?.name ? "success" : "unchecked",
                iplCityIdStatus: responseData?.id ? "success" : "unchecked",
                }));
            }
            else{
                //throw error
            }
        } catch (error) {
            console.error('Error fetching data by ID:', error);
            showSnackbar(error?.response?.data?.message || 'Error fetching data by ID', "error");
        }
        };
        fetchCityById(cityId);
    },[pageMode])

    //post and put api function
    const handleSubmitCity = async () => {
        const payload = { 
            districtId: formData?.districtId?.value,
            name: formData?.name, 
            isActive: formData?.active
        };
        //Update
        if(cityId){
            try {
                const response = await putData(`/reference/general/city/${cityId}`, payload);
                const responseMessage = response?.message;
                if(response?.success){
                //success message
                    showSnackbar(responseMessage, "success");
                    navigate('/general-master/city-list');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage, "error");
                }
            } catch (error) {
                console.error('Error updating data:', error);
            }
        }
        else{      
        //Submit
            try {
                const response = await postData('/reference/general/create', payload);
                const responseMessage = response?.message;
                if(response?.success){
                    //success message
                    showSnackbar(responseMessage, "success");
                    navigate('/general-master/city-list');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage, "error");
                }
            } catch (error) {
                console.error('Error posting data:', error);
                //catch error message
            }
        }
    };

  return (
    <DashboardLayout>
        <Card sx={{ minHeight: 500 }}>
             <CardHeader
              title={(
                  <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                  >
                      <Stack direction="row" alignItems="center" spacing={1}>
                          <IconButton onClick={() => navigate("/general-master/city-list")}>
                            <ArrowBack />
                          </IconButton>
                          <Stack direction="column" spacing={0}>
                          <MaterialTypography variant="h5" fontWeight="medium">
                              City Details
                          </MaterialTypography>
                          <MaterialTypography variant="caption" color="text">
                              Enter New City Details from around the world.
                          </MaterialTypography>
                          </Stack>
                      </Stack>
                  </Stack>
              )}
              />
            <CardContent>
                <Grid2 container spacing={2}>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Country Name*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="countryId"
                        value={formData.countryId}
                        onChange={handleChange}
                        options={countryDropdownOptions}
                        success={formData.countryIdStatus === "success"}
                        error={formData.countryIdStatus === "error"}
                        isDisabled={pageMode === "view"}
                        />
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                State Name*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="stateId"
                        options={stateOptions}
                        value={formData.stateId}
                        onChange={handleChange}
                        success={formData.stateIdStatus === "success"}
                        error={formData.stateIdStatus === "error"}
                        isDisabled={formData.countryId === "" || pageMode === "view"}
                        />
                    </Grid2> 
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                District Name*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="districtId"
                        options={districtOptions}
                        value={formData.districtId}
                        onChange={handleChange}
                        success={formData.districtIdStatus === "success"}
                        error={formData.districtIdStatus === "error"}
                        isDisabled={formData.stateId === "" || pageMode === "view"}
                        />
                    </Grid2> 
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                City Name*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="name"
                        placeholder="eg. Chennai"
                        value={formData.name}
                        onChange={handleChange}
                        success={formData.nameStatus === "success"}
                        error={formData.nameStatus === "error"}
                        disabled={pageMode === "view"}
                        />
                        {formData.nameStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                City Name should be a minimum 1 character & maximum 170 characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                    {(pageMode === "edit" || pageMode === "view") && (
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                 City ID
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="iplCityId"
                        value={formData.iplCityId}
                        onChange={handleChange}
                        success={formData.iplCityIdStatus === "success"}
                        error={formData.iplCityIdStatus === "error"}
                        disabled
                        />
                    </Grid2>
                    )}
                    <Grid2 size={{lg:2, md:2, sm: 2, xs: 2 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Active
                            </MaterialTypography>
                        </MaterialBox>
                        <FormControlLabel
                        control={
                            <Switch
                                checked={formData.active}
                                disabled={pageMode === "view"}
                                onChange={(e) =>
                                    handleChange({
                                        target: {
                                            name: "active",
                                            value: e.target.checked,
                                        },
                                    })
                                }
                                color="primary"
                            />
                        }
                        label={
                            <MaterialTypography variant="caption" fontWeight="bold">
                                {formData?.active ? "Yes" : "No"}
                            </MaterialTypography>
                        }
                        sx={{ marginLeft: 0 }}
                        />
                    </Grid2> 
                </Grid2>
            </CardContent>
            <MaterialBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
            {pageMode === "add" && (
            <>
                <MaterialButton
                sx={{ m: 2 }}
                variant="outlined"
                color="dark"
                onClick={() => navigate("/general-master/city-list")}
                >
                Cancel
                </MaterialButton>
                <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={handleSubmitCity}
                >
                Submit
                </MaterialButton>
            </>
            )}
    
            {pageMode==="edit" && (
            <>
            <MaterialButton
            variant="outlined"
            color="dark"
            sx={{ m: 2 }}
            onClick={() => navigate("/general-master/city-list")}
            >
            Cancel
            </MaterialButton>
            <MaterialButton
            sx={{ m: 2 }}
            variant="gradient"
            color="dark"
            disabled={!checkAllFields()}
            onClick={handleSubmitCity}
            >
            Update
            </MaterialButton>
            </>
            )}
            </MaterialBox>
        </Card>
    </DashboardLayout>
  )
}

export default CityForm